import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2'
import { StaticContentTemplatesComponent } from './static-content-templates.component'
import { UpdateStaticContentTemplateComponent } from './update-static-content-template/update-static-content-template.component'
import { staticContentTemplatesRoutes } from './static-content-templates.routing'
import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { HttpClientModule } from '@angular/common/http'
import { RouterModule } from '@angular/router'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { SharedModule } from '@shared/shared.module'
import { RadioModule } from '@components/radio/radio.module'
import { TextEditorModule } from '@components/text-editor/text-editor.module'
import { BreadcrumbsModule } from '@components/breadcrumbs/breadcrumbs.module'

@NgModule({
  declarations: [
    StaticContentTemplatesComponent,
    UpdateStaticContentTemplateComponent,
  ],
  imports: [
    HttpClientModule,
    CommonModule,
    BrowserAnimationsModule,
    SweetAlert2Module.forRoot(),
    RouterModule.forRoot(staticContentTemplatesRoutes, {
      scrollPositionRestoration: 'top',
    }),
    HttpClientModule,
    SharedModule,
    RadioModule,
    TextEditorModule,
    BreadcrumbsModule,
  ],
  exports: [
    StaticContentTemplatesComponent,
    UpdateStaticContentTemplateComponent,
  ],
})
export class StaticContentTemplatesModule {}
